import Panel from "@/components/Panel";
import {useAppState} from "@/store";
import {useApi} from "@/api";
import {apiUrl, dataLayerPush} from "@/helpers";
import {API_ENDPOINTS} from "@/constants";
import {toast} from "react-toastify";
import {useState} from "react";

export default function CtaSmall() {

    const {state} = useAppState()
    const {api, setLoading, loading} = useApi();

    const [sent, setSent] = useState(false)
    const [sendError, setSendError] = useState(false)

    const handleClick = async (e) => {

        e.preventDefault()

        setLoading(true)

        try {

            const response = await api.post(apiUrl(API_ENDPOINTS.send), {
                "requestId": state.requestId,
                "availabilityId": state.availability?._id,
            })

            if (response.emailSent) {
                setSent(true)
            } else {
                setSendError(true)
            }

        } catch (e) {
            toast.error(e.message)
        }
        setLoading(false)

        await dataLayerPush('book-estimate-email-submit', {
            ['book-estimate-amount']: state.estimate?.totalCost,
            ['book-estimate-movers']: state.estimate?.movers || 0,
            ['book-estimate-hours']: state.estimate?.totalTime || 0,
            ['book-estimate-trucks']: state.estimate?.trucks || 0,
            ['book-estimate-trip-fees']: state.estimate?.tripFees || 0,
            ['book-estimate-initial-date']: state.availability?.date || null,
            ['book-assigned-branch']: state.branch?.name || null,
            ['book-estimate-id']: state.customerId || null,
        })


    }


    return (
        <Panel passive={true} feature={true}>
            <div className="heading-h2 mb-[16px] text-center">Need more options?</div>
            <p className="text-big mb-[24px] text-center">
                No deposit required. Free cancellation. Quote valid for 7 days.
            </p>
            <div className="flex flex-col lg:flex-row gap-[16px] lg:gap-[32px] items-center justify-center">
                {(!sent && !sendError) && (
                    <div className={"relative"}>
                        <button onClick={handleClick} disabled={loading || !state.availability} className="btn ein-btn disabled:opacity-40">Email estimate to yourself</button>
                        {loading && (
                            <div className={"size-[48px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"}>
                                <svg viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" className={"stroke-brand-blue"} strokeWidth="3" vectorEffect="non-scaling-stroke" strokeLinecap="round" strokeDasharray="60 120"><animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"></animateTransform></circle></svg>
                            </div>
                        )}
                    </div>
                )}
                {(sent && !sendError) && (
                    <p><strong className={"text-[#00CC00]"}>Your estimate has been emailed to {state.contact.email}</strong></p>
                )}
                {(!sent && sendError) && (
                    <p>There was an error emailing your estimate. Please contact support.</p>
                )}
            </div>
        </Panel>
    )
}
